module.exports = __webpack_public_path__ + "static/media/hajj-package-1.ff77bca9.jpg";